import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DEFAULT_SORT_OPTIONS } from '../../consts/default-sort-options.const';
import { SortOption } from '../../models/sort-option.interface';
import { ElementStyleType } from '../../enums/element-style-type.enum';

@Component({
  selector: 'app-sort-by',
  templateUrl: './sort-by.component.html',
  styleUrls: ['./sort-by.component.scss']
})
export class SortByComponent {
  @Input() selectedSort?: SortOption;
  @Input() sortOptions: SortOption[] = DEFAULT_SORT_OPTIONS;
  @Input() styleType: ElementStyleType = ElementStyleType.Gray;
  @Output() selectionChanged = new EventEmitter<SortOption>();

  isOpen = false;
  sortBy($sort: any) {
    const selectedSortOption = $sort.value;
    this.selectionChanged.emit(selectedSortOption);
  }

  onShow() {
    this.isOpen = true;
  }

  onHide() {
    this.isOpen = false;
  }

  onDropdownClick(e: any): void {
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
}
